const htmlContent = `
<div id="markdown">
<h1 id="quirion">quirion</h1>
<p><a href="https://chat.celp.de/chatbot/3b1ecd1e-f194-490f-82e6-b54e67dd122c">https://chat.celp.de/chatbot/3b1ecd1e-f194-490f-82e6-b54e67dd122c</a></p>

</div>
`;
export default htmlContent
